import { Injectable } from "@angular/core";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";
import { FindOrdersTableDefinitionFactory } from "../../model/FindOrdersTableDefinitionFactory";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FindOrdersDataOrderAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: FindOrdersTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
